import { render } from "./MerchantLayout.vue?vue&type=template&id=ff2d6e54&scoped=true"
import script from "./MerchantLayout.vue?vue&type=script&lang=js"
export * from "./MerchantLayout.vue?vue&type=script&lang=js"

import "./MerchantLayout.vue?vue&type=style&index=0&id=ff2d6e54&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff2d6e54"]])

export default __exports__